/* Imports needed for all question form subclasses. */
import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
    QuestionFormBase,
    QuestionFormBaseProps,
    QuestionFormBaseState,
    mapStateToQuestionFormBaseProps,
    mapDispatchToQuestionFormBaseProps
} from '../../QuestionFormBase';
import { MULTIMEDIA_TYPES, QTYPES } from '@nexxt/common/types';
import classnames from 'classnames';
import * as _ from 'lodash';
import NotifyHOC from '../../../../../../HOC/Notifications';

/* Components used in this question form. */
import Toggle from '../../../../../common/Toggle';
import InputRadio from '../../../common/radioButton/inputRadio';
import BuilderHeader from '../../../common/builderHeader';
import QuestionSettings from '../../../common/questionSettings';
import InputRadioWithImage from '../../../common/radioButton/inputRadioWithImage';
import MultimediaBubble from '../../../common/MultimediaBubble';
import { STATIC_STORAGE_URL } from '@nexxt/common/constants';

interface Props extends QuestionFormBaseProps {
    // nothing special... yet!
}

interface States extends QuestionFormBaseState {
    // nothing special... yet!
}

class FormIconScale extends QuestionFormBase<Props, States> {
    constructor(p: QuestionFormBaseProps) {
        super(p, QTYPES.ICONS);
        // set value from question here
        const question = {
            ...this.state.question,
            showContinueButton: true
        };
        this.state = {
            ...this.state,
            question
        };
    }

    render() {
        const { isSettingBoxLayoutOpen, question } = this.state;
        const questionError =
            (this.state.showError && this.state.questionError) || {};
        // const question = this.props.currentQuestion;
        return (
            <div>
                <div className="project-add--question-builder">
                    <BuilderHeader
                        toggleSettingBoxLayout={this.toggleSettingBoxLayout}
                        isSettingBoxLayoutOpen={isSettingBoxLayoutOpen}
                        showAlert={!this.props.editEnabled}
                        alertMessages={this.getWarningMessage()}
                        question={question}
                        setValue={this.setQuestion}
                        disabled={!this.props.editEnabled}
                        errorObject={this.state.questionError}
                    />
                    <div className="builder-body">
                        {(isSettingBoxLayoutOpen && (
                            <QuestionSettings
                                onClose={this.toggleSettingBoxLayout}
                                question={question}
                                questionSettings={{
                                    allowUserEdit: true
                                }}
                                setValue={this.setQuestion}
                                disabled={!this.props.editEnabled}
                            />
                        )) ||
                            null}
                        {this.renderErrorNotes()}
                        <MultimediaBubble
                            question={question}
                            languages={this.props.currentProject.languages}
                            setValue={this.setQuestion}
                            setValueWithLanguage={
                                this.NEW_setQuestionTextTranslation
                            }
                            addNewBubble={this.NEW_addNewEditor}
                            removeBubble={this.NEW_removeEditor}
                            disabled={!this.props.editEnabled}
                            questionError={questionError}
                            settings={{ showClose: true }}
                        />
                        <div className="row">
                            <div
                                className={classnames('col-md-12 form-group', {
                                    error:
                                        questionError && questionError.iconType
                                })}
                            >
                                <label className="form-group__label form-group__label--block">
                                    Icon display for rating
                                </label>
                                <InputRadioWithImage
                                    options={[
                                        {
                                            label: 'Hearts',
                                            value: 'hearts',
                                            image: `${STATIC_STORAGE_URL}/img/heart.svg`
                                        },
                                        {
                                            label: 'Thumbs',
                                            value: 'thumbs',
                                            image: `${STATIC_STORAGE_URL}/img/thumbs.svg`
                                        },
                                        {
                                            label: 'Stars',
                                            value: 'stars',
                                            image: `${STATIC_STORAGE_URL}/img/star.svg`
                                        }
                                    ]}
                                    name="iconType"
                                    selectedValue={question.iconType}
                                    setValue={(value) =>
                                        this.setQuestion('iconType', value)
                                    }
                                    disabled={!this.props.editEnabled}
                                />
                                {questionError && questionError.iconType ? (
                                    <span className="form-group__error-msg">
                                        {questionError.iconType}
                                    </span>
                                ) : null}
                            </div>
                        </div>

                        <div className="row">
                            <div
                                className={classnames('col-md-6 form-group', {
                                    error:
                                        questionError &&
                                        questionError.iconNumber
                                })}
                            >
                                <label className="form-group__label form-group__label--block">
                                    How many icons to display for rating?
                                </label>
                                <InputRadio
                                    options={[
                                        { label: '3', value: 3 },
                                        { label: '4', value: 4 },
                                        { label: '5', value: 5 },
                                        { label: '6', value: 6 },
                                        { label: '7', value: 7 }
                                    ]}
                                    name="iconNumber"
                                    selectedValue={question.iconNumber}
                                    setValue={(value) =>
                                        this.setQuestion('iconNumber', value)
                                    }
                                    disabled={!this.props.editEnabled}
                                />
                                {questionError && questionError.iconNumber ? (
                                    <span className="form-group__error-msg">
                                        {questionError.iconNumber}
                                    </span>
                                ) : null}
                            </div>
                            <div className="col-md-6 form-group">
                                <label className="form-group__label form-group__label--block w-100">
                                    Show not applicable option
                                </label>
                                <Toggle
                                    onChange={(value) =>
                                        this.setQuestion(
                                            'showNotApplicableOption',
                                            value
                                        )
                                    }
                                    checked={question.showNotApplicableOption}
                                    disabled={!this.props.editEnabled}
                                />
                            </div>
                        </div>

                        {question.showNotApplicableOption && (
                            <MultimediaBubble
                                languages={this.props.currentProject.languages}
                                question={question}
                                setValue={this.setQuestion}
                                setValueWithLanguage={
                                    this.NEW_setQuestionTextTranslation
                                }
                                questionError={questionError}
                                keyName="notApplicableTexts"
                                disabled={!this.props.editEnabled}
                                disableAddBubble
                                defaultTextType={MULTIMEDIA_TYPES.TEXT}
                                defaultText="BUTTON.NOT_APPLICABLE"
                                questionText="Not Applicable text"
                                settings={{
                                    noBorder: true,
                                    useTranslation: true
                                }}
                            />
                        )}
                        {/** CONTINUE BUTTON */}
                        <MultimediaBubble
                            languages={this.props.currentProject.languages}
                            question={question}
                            setValue={this.setQuestion}
                            setValueWithLanguage={
                                this.NEW_setQuestionTextTranslation
                            }
                            questionError={questionError}
                            keyName="continueTexts"
                            defaultText="BUTTON.CONTINUE"
                            disabled={!this.props.editEnabled}
                            disableAddBubble
                            defaultTextType={MULTIMEDIA_TYPES.TEXT}
                            questionText="Continue button text"
                            settings={{ noBorder: true, useTranslation: true }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(
    NotifyHOC(
        connect(
            mapStateToQuestionFormBaseProps,
            mapDispatchToQuestionFormBaseProps
        )(FormIconScale)
    )
);
